import 'kit/dist/weproov-kit.css';
import './assets/stylesheets/main.scss';

import Vue from 'vue';
import Kit from 'kit';
import { VueTelInput } from 'vue-tel-input';

import App from './App.vue';
import router from './router';
import Api from '@/api';

Vue.config.productionTip = false;
Vue.use(Kit);
Vue.component('vue-tel-input', VueTelInput);

Vue.prototype.$api = Api;
Vue.prototype.$preferredCountries = ['fr'];

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
